import './index.scss';

const shopPage = () => {

	document.addEventListener('DOMContentLoaded', function () {
    initWcAccordion();

    // Re-run after WooCommerce interactivity API may re-render
    const observer = new MutationObserver(function(mutations) {
        const content = document.querySelector('.wc-block-product-filters__overlay-content');
        if (content && !content.classList.contains('accordion-initialized')) {
            initWcAccordion();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    function initWcAccordion() {
        const content = document.querySelector('.wc-block-product-filters__overlay-content');
        if (!content || content.classList.contains('accordion-initialized')) return;
        content.classList.add('accordion-initialized');

        // Get all direct filter children that have an h3
        const filterBlocks = Array.from(content.children).filter(el => {
            return el.querySelector('h3.wp-block-heading');
        });

        if (!filterBlocks.length) return;

        filterBlocks.forEach(function(block, index) {
            const h3 = block.querySelector('h3.wp-block-heading');
            if (!h3) return;

            const headingText = h3.textContent.trim();
            const itemId = 'wcAcc_' + index;
            const isFirst = index === 0;

            // Hide original h3
            h3.style.display = 'none';

            // Build accordion header
            const header = document.createElement('div');
            const svgCodeOpen = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_52_826)">
								<path d="M4.14844 7L10.1484 13L16.1484 7" stroke="#434343" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
								</g>
								<defs>
								<clipPath id="clip0_52_826">
								<rect width="20" height="20" fill="white"/>
								</clipPath>
								</defs>
								</svg>`;
			const svgCodeClose = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_52_810)">
								<path d="M3.85205 13L9.85205 7L15.8521 13" stroke="#434343" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
								</g>
								<defs>
								<clipPath id="clip0_52_810">
								<rect width="20" height="20" fill="white"/>
								</clipPath>
								</defs>
								</svg>`;
            header.classList.add('wc-acc-header');
            header.innerHTML = `
                <span class="wc-acc-title">${headingText}</span>
                <span class="wc-acc-icon">${isFirst ? svgCodeClose : svgCodeOpen}</span>
            `;
            header.setAttribute('data-target', itemId);
            header.setAttribute('aria-expanded', isFirst ? 'true' : 'false');

            // Wrap block content in collapsible body
            const body = document.createElement('div');
            body.classList.add('wc-acc-body');
            body.id = itemId;
            body.style.display = isFirst ? 'block' : 'none';

            // Move all children except h3 into body
            Array.from(block.childNodes).forEach(child => {
                if (child !== h3) body.appendChild(child.cloneNode ? child : child);
            });
            // Clear block and reassemble
            block.innerHTML = '';
            block.appendChild(h3); // keep hidden h3 for WC interactivity
            block.appendChild(header);
            block.appendChild(body);
            block.classList.add('wc-acc-item');

            // Toggle on click
            header.addEventListener('click', function() {
                const isOpen = this.getAttribute('aria-expanded') === 'true';
                const targetId = this.getAttribute('data-target');
                const targetBody = document.getElementById(targetId);

                if (isOpen) {
                    targetBody.style.display = 'none';
                    const svgCodeOpen = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
										<g clip-path="url(#clip0_52_826)">
										<path d="M4.14844 7L10.1484 13L16.1484 7" stroke="#434343" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
										</g>
										<defs>
										<clipPath id="clip0_52_826">
										<rect width="20" height="20" fill="white"/>
										</clipPath>
										</defs>
										</svg>`;
                    this.setAttribute('aria-expanded', 'false');
                    this.querySelector('.wc-acc-icon').innerHTML = svgCodeOpen;
                } else {
                    targetBody.style.display = 'block';
                    const svgCodeClose = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
										<g clip-path="url(#clip0_52_810)">
										<path d="M3.85205 13L9.85205 7L15.8521 13" stroke="#434343" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
										</g>
										<defs>
										<clipPath id="clip0_52_810">
										<rect width="20" height="20" fill="white"/>
										</clipPath>
										</defs>
										</svg>`;
                    this.setAttribute('aria-expanded', 'true');
                    this.querySelector('.wc-acc-icon').innerHTML = svgCodeClose;
                }
            });
        });
    }
});
};

export default shopPage;
